import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Item from './Item'

const Section = styled.section`
  background-color: #f5f7f7;
`

const Videos = ({ videos }) => (
  <Section color='f5f7f7' className='padding-tb-50px sm-ptb-35px'>
    <div className='container'>
      <div className='row justify-content-center'>
        <div className='col-lg-7'>
          <div className='firo-title dark text-center wow fadeInUp' data-wow-delay='0.2s'>
            <h2 className='title'>Videos</h2>
            <div className='description'>Find the latest and most relevant news, talks, and webinars in the Node.js ecosystem</div>
          </div>
        </div>
      </div>
      <div className='row'>
        {
          videos.map((video, index) => <Item key={index} {...video} />)
        }
      </div>
    </div>
  </Section>
)

Videos.propTypes = {
  videos: PropTypes.arrayOf(PropTypes.shape())
}

Videos.defaultProps = {
  videos: []
}

export default Videos
